import { CommunityRequestListingSignupPanel } from "components/communities/show-community/community-request-listing-signup-panel";
import { defaultLinkStyle } from "components/ui/link";
import React, { useCallback } from "react";
import { ListableCommunity } from "../props";

interface LayoutItemAvailabilityMissingProps {
    community: ListableCommunity;
    canRequestAvailability: boolean;
}

export const LayoutItemAvailabilityMissing: React.FC<
    LayoutItemAvailabilityMissingProps
> = props => {
    const { community, canRequestAvailability } = props;

    const [isRequestDialogOpen, setIsRequestDialogOpen] = React.useState(false);

    const requestAvailability = useCallback(() => {
        setIsRequestDialogOpen(true);
    }, []);

    const closeRequestDialog = useCallback(() => {
        setIsRequestDialogOpen(false);
    }, []);

    const onRequestSuccess = useCallback(() => {
        closeRequestDialog();
    }, [closeRequestDialog]);

    return (
        <>
            {isRequestDialogOpen ? (
                <CommunityRequestListingSignupPanel
                    communityId={community.id}
                    onDismiss={closeRequestDialog}
                    onSuccess={onRequestSuccess}
                />
            ) : null}
            {canRequestAvailability ? (
                <dd className="mt-1 flex text-sm flex items-center space-x-1">
                    <a
                        href="#"
                        onClick={e => {
                            e.preventDefault();
                            requestAvailability();
                        }}
                        className={`${defaultLinkStyle} text-sm`}>
                        Request Availability
                    </a>
                </dd>
            ) : (
                <dd className="mt-1 flex text-sm text-red-500 flex items-center space-x-1">
                    Unknown
                </dd>
            )}
        </>
    );
};
